module.exports = __webpack_public_path__ + "static/world-map-1a41f9377627213b88a5f637b50edb13.png";